import { Button, type ButtonProps, Group, GroupProps } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const ModalFooter = ({
  onClose,
  children,
  closeButtonProps,
  ...rest
}: {
  onClose?: () => void;
  closeButtonProps?: ButtonProps & { 'data-testid'?: string };
  children?: ReactNode;
} & GroupProps) => {
  const { t } = useTranslation('translation');
  return (
    <Group gap={'xs'} justify={'flex-end'} wrap={'nowrap'} {...rest}>
      {onClose && (
        <Button
          onClick={onClose}
          data-testid='modal-cancel'
          {...closeButtonProps}
        >
          {t('action.cancel')}
        </Button>
      )}
      {children}
    </Group>
  );
};